import React from "react";
import Layout from "../components/layout"
import Tanks from "../images/tanks.jpg";

export default () => (
  <Layout>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <h2 className="is-size-1">About Monitaur</h2>
    </div>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <img src={Tanks} alt="Tanks"></img>
    </div>
    <div className="is-size-4" style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <p>
        Monitaur derives it's name from the ancient greek tale of Daedalus and the Minotaur.
      </p>
    </div>
    <div className="is-size-4" style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <p>
        We are a company dedicated to getting you up and running with monitoring solutions as quickly as possible.
      </p>
    </div>
  </Layout>
);
